import { createRoute } from "@tanstack/solid-router";
import { Navigate } from "@/lib/u-router";
import { appRoute } from "./route";

interface SavedBible {
  version: string;
  bookAbbr: string;
  chapter: string;
}

function isSavedBible(obj: unknown): obj is SavedBible {
  if (obj === null || typeof obj !== "object") {
    return false;
  }
  const version: unknown = Reflect.get(obj, "version");
  const bookAbbr: unknown = Reflect.get(obj, "bookAbbr");
  const chapter: unknown = Reflect.get(obj, "chapter");
  return typeof version === "string" && typeof bookAbbr === "string" && typeof chapter === "string";
}

function IndexRedirect() {
  const getSaved = (): SavedBible => {
    try {
      const saved = localStorage.getItem("last-read-bible");
      if (saved) {
        const parsed: unknown = JSON.parse(saved);
        if (isSavedBible(parsed)) {
          return parsed;
        }
      }
    } catch {
      /* ignore storage or parsing errors */
    }
    return { version: "kjv", bookAbbr: "gen", chapter: "1" };
  };

  const loc = getSaved();
  return (
    <Navigate
      to="/bible/$version/$bookAbbr/$chapter"
      params={{
        version: loc.version,
        bookAbbr: loc.bookAbbr,
        chapter: loc.chapter,
      }}
    />
  );
}

export const indexRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/",
  component: IndexRedirect,
});
